import { render } from "./ViewBalanceGuesses.vue?vue&type=template&id=e565633a&scoped=true"
import script from "./ViewBalanceGuesses.vue?vue&type=script&lang=js"
export * from "./ViewBalanceGuesses.vue?vue&type=script&lang=js"

import "./ViewBalanceGuesses.vue?vue&type=style&index=0&id=e565633a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e565633a"]])

export default __exports__